import { Culture } from "../Data/Culture";
import * as Topics from "../Data/Topics";
import Gameplay from "../Gameplay";
import { Button } from "./Button";
import CultureBackground from "./CultureBackground";
import EgyptBackground from "./EgyptBackground";
import IndiaBackground from "./IndiaBackground";
import MexicoBackground from "./MexicoBackground";

export default class CultureBackgroundManager extends PIXI.Container {
    public get swapComplete(): boolean {
        return this._swapComplete;
    }
    protected _size?: PIXI.Point;
    private _currentCulture: Culture = Gameplay.Instance.currentCulture;
    private _swapComplete: boolean = false;
    private readonly _messageTokens: any[];
    private readonly _bgElements: CultureBackground[];

    constructor() {
        super();
        this._messageTokens = new Array<any>();
        this._messageTokens.push(
            PubSub.subscribe(Topics.CULTURE_BUTTON_PRESSED, this.onCultureButtonPressed.bind(this)),
            PubSub.subscribe(Topics.CULTURE_CHANGE_BEGIN, this.onCultureChangeBegin.bind(this)),
            PubSub.subscribe(Topics.CULTURE_CHANGE_COMPLETE, this.onCultureChangeComplete.bind(this)),
            PubSub.subscribe(Topics.START_INTRO, this.startIntro.bind(this)),
        );

        const MexicoContainer = new MexicoBackground();
        const IndiaContainer = new IndiaBackground();
        const EgyptContainer = new EgyptBackground();

        this._bgElements = [MexicoContainer, IndiaContainer, EgyptContainer]; // order matters

        this.addChild(...this._bgElements);

    }
    public onResize(pSize: PIXI.Point) {
        this._size = pSize;
        for (let i = 0; i < Culture.NumElements; i++) {
            const container = this._bgElements[i];
            container.onResize(pSize);

            if (i === this._currentCulture) {
                container.visible = true;
                // container.position.set(0, 0);
            }
            else {
                container.visible = false;
                // container.position.set(0, -this._size.y);
            }
        }
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions) {
        this._messageTokens.forEach(PubSub.unsubscribe);
        super.destroy(pOptions);
    }

    protected startIntro() {
        for (let i = 0; i < Culture.NumElements; i++) {
            const container = this._bgElements[i];
            container.visible = true;
            if (i === this._currentCulture) {
                container.visible = true;
                // container.position.set(0, 0);
            }
            else {
                container.visible = false;
                // container.position.set(0, -this._size!.y);
            }
        }

        const startingCulture = this._bgElements[this._currentCulture];
        startingCulture.AnimateIn(() => {
            setTimeout(() => {
                PubSub.publishSync(Topics.INTRO_COMPLETED, null);
            }, 1000);
        }, 1);
    }

    protected onCultureButtonPressed(pTopic: string, pData: Button): void {
        const fromCulture = this._currentCulture;
        const nextCulture = (fromCulture + 1) % Culture.NumElements;
        PubSub.publishSync(Topics.CULTURE_CHANGE_BEGIN, nextCulture);
    }

    protected onCultureChangeBegin(pTopic: string, pData: Culture): void {
        const fromCulture = this._currentCulture;
        const toCulture = pData;
        this._swapComplete = false;

        for (let i = 0; i < Culture.NumElements; i++) {

            const container = this._bgElements[i];

            if (i === fromCulture) {
                container.AnimateOut();
            }
            else if (i === toCulture){
                container.visible = true;
                container.AnimateIn(() => {
                    this._swapComplete = true;
                    PubSub.publishSync(Topics.ALL_BG_SWAPS_COMPLETE, this);
                });
            }
            else {
                container.visible = false;
                // container.position.set(0, -this._size!.y);
            }
        }
        this._currentCulture = toCulture;
    }

    protected onCultureChangeComplete(pTopic: string, pData: Culture): void {
        // TODO: not sure if we need this block
    }
}
